class CardForm extends HTMLElement {
  constructor() {
    super();

    this.card = this.closest('.card');
    this.cardForm = this;
    this.submitButton = this.querySelector('button[type="submit"]');
    this.addTocartText = this.submitButton.querySelector('span:nth-child(1)');
    this.soldOutText = this.submitButton.querySelector('.sold-out-message');
    this.inputs = [...this.querySelectorAll('.product-form__input input')];
    this.selectedSize = '';
    this.sizeSelectButton = this.querySelector('[data-size-select]');
    this.cardInner = this.closest('.card__inner');
    this.variantSelect = this.querySelector('variant-selects');
    this.cardOptions = JSON.parse(this.variantSelect.querySelector('script[data-card-options]').textContent);
    this.variantData = JSON.parse(this.variantSelect.querySelector('script[data-selected-variant]').textContent);
    this.colorRadios = [...this.card.querySelectorAll('card-swatches input')];
    this.variantIdInput = this.querySelector('.product-variant-id');
    this.hasSizeVariant = true;

    this.selectedColorVariant = this.colorRadios.find(radio => radio.checked)?.value || '';
  }

  connectedCallback() {
    this.addEventListeners();
    this.resetForm();
    this.updateVariantId();
    this.checkForVariant();
    this.updateUnavailableSizes(this.selectedColorVariant);
  }

  checkForVariant() {
    const hasVariant = this.variantSelect.querySelector('.product-form__input');
    if (!hasVariant) {
      this.enableSubmitButton();
      this.cardForm.classList.add('visible');
      this.hasSizeVariant = false;
    }
  }

  toggleCardForm(event) {
    event.preventDefault();
    this.cardForm.classList.toggle('active');
  }

  markAsSelected(input) {
    this.cardForm.classList.add('is-selected');
    this.selectedSize = input.value;
    this.updateVariantId();
  }

  resetForm() {
    this.cardForm.classList.remove('active', 'is-selected');
    this.inputs.forEach(input => input.checked = false);
  }

  addEventListeners() {
    this.sizeSelectButton.addEventListener('click', this.toggleCardForm.bind(this));
    this.cardInner.addEventListener('mouseleave', this.resetForm.bind(this));

    this.inputs.forEach(input =>
      input.addEventListener('change', () => this.markAsSelected(input))
    );

    if (this.colorRadios.length) {
      this.colorRadios.forEach(radio =>
        radio.addEventListener('change', this.updateVariantId.bind(this))
      );
    }
  }

  enableSubmitButton() {
    this.submitButton.removeAttribute('aria-disabled');
    this.addTocartText.classList.remove('hidden');
    this.soldOutText.classList.add('hidden');
  }

  disableSubmitButton() {
    this.submitButton.setAttribute('aria-disabled', 'true');
    this.addTocartText.classList.add('hidden');
    this.soldOutText.classList.remove('hidden');
  }

  updateVariantId() {
    const selectedSize = this.selectedSize;
    let selectedColor = this.colorRadios.find(radio => radio.checked)?.value || '';

    let selectedVariant = this.variantData.find(variant =>
      variant.option1 === selectedSize && variant.option2 === selectedColor
    );

    if (!this.hasSizeVariant) {
      selectedVariant = this.variantData.find(variant => variant.option1 === selectedColor);
    }

    if (selectedColor === '') {
      selectedVariant = this.variantData.find(variant => variant.option1 === selectedSize);
    }

    if (selectedVariant) {
      this.variantIdInput.value = selectedVariant.id;
      this.enableSubmitButton();
    } else {
      this.disableSubmitButton();
    }
  }

  updateUnavailableSizes(selectedColor) {
    const availableSizesForColor = this.variantData
      .filter(variant => variant.option2 === selectedColor && variant.available)
      .map(variant => variant.option1);

    const allSizesForColor = this.variantData
      .filter(variant => variant.option2 === selectedColor)
      .map(variant => variant.option1);

    const sizeSelects = this.variantSelect.querySelectorAll('input');

    if (this.cardOptions.length > 1) {
      sizeSelects.forEach(input => {
        if (!allSizesForColor.includes(input.value) || !availableSizesForColor.includes(input.value)) {
          input.setAttribute('disabled', 'true');
        } else {
          input.removeAttribute('disabled');
        }
      });
    };
  }
}

customElements.define('card-form', CardForm);
